import React from 'react'

const Google = ({ id = '' }: { id?: string }) => {
  const id0 = `paint0_linear_${id}`
  const id1 = `paint1_linear_${id}`
  const id2 = `paint2_linear_${id}`
  const id3 = `paint3_linear_${id}`

  return (
    <svg
      width='144'
      height='48'
      viewBox='0 0 144 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <rect
        x='0.5'
        y='0.5'
        width='143'
        height='47'
        rx='7.5'
        fill='black'
        stroke='#949AA4'
      />
      <path
        d='M50.7441 13.4095C50.7441 14.2361 50.5374 14.9593 50.0208 15.4759C49.4009 16.0958 48.6777 16.4058 47.7478 16.4058C46.8179 16.4058 46.0947 16.0958 45.4748 15.4759C44.8549 14.856 44.5449 14.1328 44.5449 13.2029C44.5449 12.273 44.8549 11.5498 45.4748 10.9299C46.0947 10.31 46.8179 10 47.7478 10C48.1611 10 48.5744 10.1033 48.9877 10.31C49.4009 10.5166 49.7109 10.7232 49.9175 11.0332L49.4009 11.5498C48.9877 11.0332 48.4711 10.8266 47.7478 10.8266C47.1279 10.8266 46.508 11.0332 46.0947 11.5498C45.5781 11.9631 45.3715 12.583 45.3715 13.3062C45.3715 14.0295 45.5781 14.6494 46.0947 15.0626C46.6113 15.4759 47.1279 15.7859 47.7478 15.7859C48.4711 15.7859 48.9877 15.5792 49.5042 15.0626C49.8142 14.7527 50.0208 14.3394 50.0208 13.8228H47.7478V13.0996H50.7441C50.7441 13.0996 50.7441 13.3062 50.7441 13.4095Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M55.497 10.8268H52.7074V12.7898H55.2904V13.5131H52.7074V15.4761H55.497V16.3027H51.8809V10.1035H55.497V10.8268Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M58.9072 16.3027H58.0806V10.8268H56.3242V10.1035H60.6636V10.8268H58.9072V16.3027Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M63.6602 16.3027V10.1035H64.4867V16.3027H63.6602Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M67.999 16.3027H67.1725V10.8268H65.416V10.1035H69.6521V10.8268H67.8957V16.3027H67.999Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M77.8138 15.4759C77.1939 16.0958 76.4707 16.4058 75.5408 16.4058C74.6109 16.4058 73.8877 16.0958 73.2678 15.4759C72.6478 14.856 72.3379 14.1328 72.3379 13.2029C72.3379 12.273 72.6478 11.5498 73.2678 10.9299C73.8877 10.31 74.6109 10 75.5408 10C76.4707 10 77.1939 10.31 77.8138 10.9299C78.4337 11.5498 78.7437 12.273 78.7437 13.2029C78.7437 14.1328 78.4337 14.856 77.8138 15.4759ZM73.8877 14.9593C74.301 15.3726 74.9209 15.6826 75.5408 15.6826C76.1607 15.6826 76.7806 15.4759 77.1939 14.9593C77.6072 14.5461 77.9171 13.9261 77.9171 13.2029C77.9171 12.4797 77.7105 11.8597 77.1939 11.4465C76.7806 11.0332 76.1607 10.7232 75.5408 10.7232C74.9209 10.7232 74.301 10.9299 73.8877 11.4465C73.4744 11.8597 73.1644 12.4797 73.1644 13.2029C73.1644 13.9261 73.3711 14.5461 73.8877 14.9593Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M79.8789 16.3027V10.1035H80.8088L83.805 14.9595V13.7197V10.1035H84.6316V16.3027H83.805L80.6021 11.24V12.4799V16.3027H79.8789Z'
        fill='white'
        stroke='white'
        strokeWidth='0.281869'
        strokeMiterlimit='10'
      />
      <path
        d='M72.1286 25.3951C69.649 25.3951 67.6859 27.2548 67.6859 29.8378C67.6859 32.3175 69.649 34.2805 72.1286 34.2805C74.6083 34.2805 76.5714 32.4208 76.5714 29.8378C76.5714 27.1515 74.6083 25.3951 72.1286 25.3951ZM72.1286 32.4208C70.7855 32.4208 69.649 31.2843 69.649 29.7345C69.649 28.1847 70.7855 27.0482 72.1286 27.0482C73.4718 27.0482 74.6083 28.0814 74.6083 29.7345C74.6083 31.2843 73.4718 32.4208 72.1286 32.4208ZM62.52 25.3951C60.0403 25.3951 58.0772 27.2548 58.0772 29.8378C58.0772 32.3175 60.0403 34.2805 62.52 34.2805C64.9996 34.2805 66.9627 32.4208 66.9627 29.8378C66.9627 27.1515 64.9996 25.3951 62.52 25.3951ZM62.52 32.4208C61.1768 32.4208 60.0403 31.2843 60.0403 29.7345C60.0403 28.1847 61.1768 27.0482 62.52 27.0482C63.8631 27.0482 64.9996 28.0814 64.9996 29.7345C64.9996 31.2843 63.8631 32.4208 62.52 32.4208ZM51.0515 26.7382V28.598H55.4942C55.3909 29.6312 54.9776 30.4577 54.461 30.9743C53.8411 31.5942 52.8079 32.3175 51.0515 32.3175C48.2619 32.3175 46.1955 30.1478 46.1955 27.3581C46.1955 24.5685 48.3652 22.3988 51.0515 22.3988C52.498 22.3988 53.6345 23.0187 54.461 23.742L55.8042 22.3988C54.6677 21.3656 53.2212 20.5391 51.1548 20.5391C47.4353 20.5391 44.2324 23.6386 44.2324 27.3581C44.2324 31.0776 47.4353 34.1772 51.1548 34.1772C53.2212 34.1772 54.6677 33.5573 55.9075 32.2142C57.1473 30.9743 57.5606 29.2179 57.5606 27.8747C57.5606 27.4615 57.5606 27.0482 57.4573 26.7382H51.0515ZM97.9585 28.1847C97.5452 27.1515 96.512 25.3951 94.239 25.3951C91.966 25.3951 90.1062 27.1515 90.1062 29.8378C90.1062 32.3175 91.966 34.2805 94.4456 34.2805C96.4087 34.2805 97.6485 33.0407 98.0618 32.3175L96.6153 31.2843C96.0987 32.0075 95.4788 32.5241 94.4456 32.5241C93.4124 32.5241 92.7925 32.1108 92.2759 31.181L98.1651 28.7013L97.9585 28.1847ZM91.966 29.6312C91.966 27.9781 93.3091 27.0482 94.239 27.0482C94.9622 27.0482 95.6855 27.4615 95.8921 27.9781L91.966 29.6312ZM87.11 33.8673H89.073V20.9523H87.11V33.8673ZM84.0104 26.3249C83.4938 25.8084 82.6672 25.2918 81.634 25.2918C79.4643 25.2918 77.3979 27.2548 77.3979 29.7345C77.3979 32.2142 79.361 34.0739 81.634 34.0739C82.6672 34.0739 83.4938 33.5573 83.9071 33.0407H84.0104V33.6606C84.0104 35.3137 83.0805 36.2436 81.634 36.2436C80.4975 36.2436 79.671 35.4171 79.4643 34.6938L77.8112 35.4171C78.3278 36.5536 79.5676 38 81.7373 38C84.0104 38 85.8701 36.6569 85.8701 33.454V25.6017H84.0104V26.3249ZM81.7373 32.4208C80.3942 32.4208 79.2577 31.2843 79.2577 29.7345C79.2577 28.1847 80.3942 27.0482 81.7373 27.0482C83.0805 27.0482 84.1137 28.1847 84.1137 29.7345C84.1137 31.2843 83.0805 32.4208 81.7373 32.4208ZM106.947 20.9523H102.298V33.8673H104.261V29.0112H106.947C109.117 29.0112 111.183 27.4615 111.183 24.9818C111.183 22.5021 109.117 20.9523 106.947 20.9523ZM107.051 27.1515H104.261V22.7088H107.051C108.497 22.7088 109.324 23.9486 109.324 24.8785C109.22 26.015 108.394 27.1515 107.051 27.1515ZM118.932 25.2918C117.486 25.2918 116.039 25.9117 115.523 27.2548L117.279 27.9781C117.692 27.2548 118.312 27.0482 119.036 27.0482C120.069 27.0482 120.999 27.6681 121.102 28.7013V28.8046C120.792 28.598 119.965 28.288 119.139 28.288C117.279 28.288 115.419 29.3212 115.419 31.181C115.419 32.9374 116.969 34.0739 118.622 34.0739C119.965 34.0739 120.585 33.454 121.102 32.8341H121.205V33.8673H123.065V28.9079C122.858 26.6349 121.102 25.2918 118.932 25.2918ZM118.726 32.4208C118.106 32.4208 117.176 32.1108 117.176 31.2843C117.176 30.2511 118.312 29.9411 119.242 29.9411C120.069 29.9411 120.482 30.1478 120.999 30.3544C120.792 31.5942 119.759 32.4208 118.726 32.4208ZM129.574 25.6017L127.405 31.181H127.301L125.028 25.6017H122.962L126.371 33.454L124.408 37.7934H126.371L131.641 25.6017H129.574ZM112.217 33.8673H114.18V20.9523H112.217V33.8673Z'
        fill='white'
      />
      <path
        d='M12.5166 10.6191C12.2066 10.9291 12 11.4457 12 12.0656V34.8992C12 35.5191 12.2066 36.0357 12.5166 36.3457L12.6199 36.449L25.4315 23.6374V23.5341V23.4307L12.5166 10.6191Z'
        fill={`url(#${id0})`}
      />
      <path
        d='M29.6677 27.9775L25.4316 23.7414V23.5347V23.4314L29.6677 19.1953L29.771 19.2986L34.8337 22.1916C36.2802 23.0181 36.2802 24.3613 34.8337 25.1878L29.6677 27.9775Z'
        fill={`url(#${id1})`}
      />
      <path
        d='M29.77 27.8746L25.4305 23.5352L12.5156 36.4501C13.0322 36.9667 13.7555 36.9667 14.6853 36.5534L29.77 27.8746Z'
        fill={`url(#${id2})`}
      />
      <path
        d='M29.77 19.1954L14.6853 10.6199C13.7555 10.1033 13.0322 10.2066 12.5156 10.7232L25.4305 23.5348L29.77 19.1954Z'
        fill={`url(#${id3})`}
      />
      <path
        opacity='0.2'
        d='M29.6686 27.7705L14.6873 36.2427C13.8607 36.7593 13.1375 36.656 12.6209 36.2427L12.5176 36.346L12.6209 36.4493C13.1375 36.8626 13.8607 36.9659 14.6873 36.4493L29.6686 27.7705Z'
        fill='black'
      />
      <path
        opacity='0.12'
        d='M12.5168 36.2433C12.2068 35.9334 12.1035 35.4168 12.1035 34.7969V34.9002C12.1035 35.5201 12.3102 36.0367 12.6201 36.3467V36.2433H12.5168Z'
        fill='black'
      />
      <path
        opacity='0.12'
        d='M34.832 24.8783L29.666 27.7712L29.7693 27.8746L34.832 24.9816C35.5552 24.5683 35.8652 24.0518 35.8652 23.5352C35.8652 24.0518 35.4519 24.465 34.832 24.8783Z'
        fill='black'
      />
      <path
        opacity='0.25'
        d='M14.6865 10.7231L34.8338 22.1916C35.4537 22.6048 35.867 23.0181 35.867 23.5347C35.867 23.0181 35.557 22.5015 34.8338 22.0882L14.6865 10.6198C13.24 9.79324 12.1035 10.5165 12.1035 12.1696V12.2729C12.1035 10.6198 13.24 9.89656 14.6865 10.7231Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id={id0}
          x1='24.2947'
          y1='11.869'
          x2='6.95523'
          y2='29.2085'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset='0.00657445' stopColor='#00A1FF' />
          <stop offset='0.2601' stopColor='#00BEFF' />
          <stop offset='0.5122' stopColor='#00D2FF' />
          <stop offset='0.7604' stopColor='#00DFFF' />
          <stop offset='1' stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id={id1}
          x1='36.729'
          y1='23.5362'
          x2='11.7289'
          y2='23.5362'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset='0.4087' stopColor='#FFBD00' />
          <stop offset='0.7754' stopColor='#FFA500' />
          <stop offset='1' stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id={id2}
          x1='27.4215'
          y1='25.9075'
          x2='3.90779'
          y2='49.4212'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset='1' stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id={id3}
          x1='9.30994'
          y1='3.05301'
          x2='19.8099'
          y2='13.5528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset='0.0685' stopColor='#2DA771' />
          <stop offset='0.4762' stopColor='#15CF74' />
          <stop offset='0.8009' stopColor='#06E775' />
          <stop offset='1' stopColor='#00F076' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Google
